export const PURPOSES = [
  { key: "Infographic", label: "Infographic", desc: "Multi-section visual with data, icons, and hierarchy" },
  { key: "Listicle Image", label: "Listicle Image", desc: "Numbered list formatted as a shareable image" },
  { key: "Step-by-Step Process", label: "Step-by-Step Process", desc: "Sequential process flow with numbered steps" },
  { key: "Comparison Visual", label: "Comparison Visual", desc: "Side-by-side or vs. comparison layout" },
  { key: "Quote Card", label: "Quote Card", desc: "Key insight or quote as a shareable card" },
  { key: "Stats / Data Visual", label: "Stats / Data Visual", desc: "Key numbers visualized with charts or callouts" },
  { key: "Checklist Image", label: "Checklist Image", desc: "Actionable checklist as a saveable image" },
  { key: "How-To Visual", label: "How-To Visual", desc: "Instructional visual showing how to do something" },
  { key: "Timeline", label: "Timeline", desc: "Chronological progression or milestones" },
  { key: "Tips & Tricks", label: "Tips & Tricks", desc: "Pro tips formatted as a visual guide" },
];

export const STYLES = [
  { key: "Flat Design", label: "Flat Design", desc: "Bold colors, geometric shapes, clean hierarchy" },
  { key: "Gradient Modern", label: "Gradient / Modern", desc: "Smooth gradients, layered depth, contemporary" },
  { key: "Line Art", label: "Line Art / Outline", desc: "Minimal lines, whitespace-driven structure" },
  { key: "3D Isometric", label: "3D Isometric", desc: "3D geometric data representations" },
  { key: "Bold Editorial", label: "Bold / Editorial", desc: "High-impact typography, punchy contrast" },
  { key: "Infographic Classic", label: "Infographic Classic", desc: "Traditional flow, icons, progress bars" },
  { key: "Organic / Hand-Drawn", label: "Organic / Hand-Drawn", desc: "Warm, sketch-style, approachable" },
  { key: "Minimalist", label: "Minimalist", desc: "Maximum whitespace, extreme restraint" },
  { key: "Retro / Vintage", label: "Retro / Vintage", desc: "Nostalgic, muted palette, character" },
  { key: "Corporate / Professional", label: "Corporate / Professional", desc: "Polished grid, business-formal" },
];

export const RATIOS = [
  { key: "1:1", label: "Square 1:1" },
  { key: "16:9", label: "Landscape 16:9" },
  { key: "9:16", label: "Portrait 9:16" },
  { key: "4:5", label: "Social Portrait 4:5" },
  { key: "5:4", label: "Social Landscape 5:4" },
];

export const TEXT_DENSITIES = [
  { key: "concise", label: "Concise", desc: "Key points only — minimal text, icons do the work" },
  { key: "medium", label: "Medium", desc: "Balanced — headlines with brief supporting text" },
  { key: "detailed", label: "Detailed", desc: "Comprehensive — full descriptions per item" },
];

export const ENHANCE_OPTIONS = [
  { key: "overall", label: "Overall Quality", desc: "Sharpen everything — text, colors, details" },
  { key: "text-clarity", label: "Text Clarity", desc: "Make all text perfectly crisp and legible" },
  { key: "color-vibrancy", label: "Color Vibrancy", desc: "Boost color saturation and contrast" },
  { key: "detail-sharpness", label: "Detail Sharpness", desc: "Refine icons, shapes, and edges" },
];

export const LOADING_MESSAGES = [
  "Structuring your visual layout...",
  "Arranging content hierarchy...",
  "Applying brand colors and style...",
  "Rendering icons and data elements...",
  "Final quality pass...",
];

export const FALLBACK_MODEL_REGISTRY = {
  openai: {
    "gpt-image-1": { label: "GPT Image 1", use_case: "Best for infographics & structured data visuals" },
  },
  gemini: {
    "gemini-2.5-flash-image": { label: "Gemini 2.5 Flash", use_case: "Fast image gen with conversational editing (Nano Banana)" },
    "gemini-3.1-flash-image-preview": { label: "Gemini 3.1 Flash", use_case: "4K resolution, top-tier quality (Nano Banana 2)" },
  },
};

export const PROVIDER_LABELS = {
  openai: "OpenAI",
  gemini: "Google Gemini",
};

export const PROVIDER_COLORS = {
  openai: "text-emerald-400",
  gemini: "text-blue-400",
};

export function getStructurePlaceholder(purpose) {
  const placeholders = {
    "Infographic": "1. Main insight or header\n2. Supporting data point\n3. Key statistic: 85% of...\n4. Process step or finding\n5. Call to action or takeaway",
    "Listicle Image": "1. First item on the list\n2. Second item\n3. Third item\n4. Fourth item\n5. Fifth item",
    "Step-by-Step Process": "Step 1: [Action]\nStep 2: [Action]\nStep 3: [Action]\nStep 4: [Result]",
    "Comparison Visual": "Option A: [Feature 1, Feature 2, Price]\nvs.\nOption B: [Feature 1, Feature 2, Price]",
    "Quote Card": "\"Your key quote or insight goes here.\"\n— Attribution Name, Title",
    "Stats / Data Visual": "85% of businesses...\n3x increase in...\n$1.2M average...\n47% reduction in...",
    "Checklist Image": "[ ] First checklist item\n[ ] Second item\n[ ] Third item\n[ ] Fourth item\n[ ] Fifth item",
    "How-To Visual": "Step 1: What to do first\nStep 2: Next action\nStep 3: Then this\nResult: What you get",
    "Timeline": "2022: First milestone\n2023: Second milestone\n2024: Third milestone\n2025: Current state",
    "Tips & Tricks": "Tip 1: Quick win description\nTip 2: Another actionable tip\nTip 3: Pro-level advice\nTip 4: Common mistake to avoid",
  };
  return placeholders[purpose] || placeholders["Infographic"];
}
